module.exports = __webpack_public_path__ + "img/1531248029.ae4ab905.jpg";